module.exports = __webpack_public_path__ + "img/Robo.5c6f8185.svg";